import React from "react";
import {View, Image, TouchableOpacity} from "react-native";
import { useNavigation } from '@react-navigation/native';
import styles from './pt-header-styles';
import PtIcon from "../core/pt-icon/pt-icon";
import {styleVars} from "../../app-style-vars";
import PtText from "../core/pt-text/pt-text";
import {getTranslation} from "../../helpers/getTranslation";

export default function PtHeader({headerOptions}:any) {

  const headerTitle = getTranslation(headerOptions.headerTitle) || headerOptions.headerTitle || 'App screen title';

  const nonavigationNavigation = {
    navigate: (param:any) => {return false},
    goBack: () => {return false},
  }

  const navigation = headerOptions.nonavigation ? nonavigationNavigation : useNavigation();

  const openMenu = () => {
    alert('Some content presented when menu icon in header is pressed');
  };

  const goHome = () => {
    navigation.navigate('Home');
  };

  const goBack = () => {
    navigation.goBack();
  };

  const openLivechat = () => {
    alert('Some content presented when livechat icon in header is pressed');
  };

  const openLocator = () => {
    alert('Some content presented when locator icon in header is pressed');
  };

  const openSearch = () => {
    alert('Some content presented when search icon in header is pressed');
  };

  const openSettings = () => {
    /** for now this will open first full screen */
    navigation.navigate('fullScreen1');
  };

  const openUserSettings = () => {
    navigation.navigate('MyAccount');
  };

  return(
    <View style={styles.headerContainer}>
      {headerOptions.showLogo ?
        <View style={styles.logoRow}>
          <View style={styles.logoContainer}>
            <View style={styles.logoWrapper}>
              <TouchableOpacity onPress={() => navigation.navigate('Home')}>
                <Image source={require('../../assets/images/BOSCH_RGB.png')} style={styles.logo}/>
              </TouchableOpacity>
            </View>
          </View>
          <View style={styles.siteTitleContainer}>
            <PtText style={{textAlign: 'right', fontWeight: 'bold', lineHeight:styleVars.rem(1.25)}}>{getTranslation('application.main.title')}</PtText>
          </View>
        </View>
        : null
      }
      <View style={styles.headerInnerContainer}>
        <View style={styles.headerLeftAreaContainer}>
          { headerOptions.menuArea === 'menu' ?
            <View style={styles.headerIconContainer}>
              <TouchableOpacity key={`headerMenuButton`} onPress={() => openMenu()}>
                  <PtIcon iconName={`list-view-mobile`} iconSize={styleVars.rem(1.5)}/>
              </TouchableOpacity>
            </View>
            : null
          }
          { headerOptions.menuArea === 'home' ?
            <View style={styles.headerIconContainer}>
              <TouchableOpacity onPress={() => goHome()}>
                  <PtIcon iconName={`home`} iconSize={styleVars.rem(1.5)}/>
              </TouchableOpacity>
            </View>
            : null
          }
          { headerOptions.menuArea === 'back' ?
            <View style={styles.headerIconContainer}>
              <TouchableOpacity onPress={() => goBack()}>
                  <PtIcon iconName={`back-left`} iconSize={styleVars.rem(1.5)}/>
              </TouchableOpacity>
            </View>
            : null
          }
        </View>

        <View style={styles.headerTitleContainer}>
          <PtText style={styles.headerTitle}>{headerTitle}</PtText>
        </View>
        <View style={styles.headerRightAreaContainer}>
          { headerOptions.headerIcons.includes('livechat') ?
            <View style={styles.headerIconContainer}>
              <TouchableOpacity onPress={() => openLivechat()}>
                <PtIcon iconName={`livechat`} iconSize={styleVars.rem(1.5)} iconColor={styleVars.boschDarkBlue}/>
              </TouchableOpacity>
            </View>
            : null
          }

          { headerOptions.headerIcons.includes('locator') ?
            <View style={styles.headerIconContainer}>
            <TouchableOpacity onPress={() => openLocator()}>
                <PtIcon iconName={`locator`} iconSize={styleVars.rem(1.5)} iconColor={styleVars.boschDarkBlue}/>
            </TouchableOpacity>
            </View>
            : null
          }

          { headerOptions.headerIcons.includes('search') ?
            <View style={styles.headerIconContainer}>
              <TouchableOpacity onPress={() => openSearch()}>
                <PtIcon iconName={`search`} iconSize={styleVars.rem(1.5)} iconColor={styleVars.boschDarkBlue}/>
              </TouchableOpacity>
            </View>
            : null
          }

          { headerOptions.headerIcons.includes('settings') ?
            <View style={styles.headerIconContainer}>
              <TouchableOpacity onPress={() => openSettings()}>
                <PtIcon iconName={`settings`} iconSize={styleVars.rem(1.5)} iconColor={styleVars.boschDarkBlue}/>
              </TouchableOpacity>
            </View>
            : null
          }

          { headerOptions.headerIcons.includes('userSettings') ?
            <View style={styles.headerIconContainer}>
              <TouchableOpacity onPress={() => openUserSettings()}>
                <PtIcon iconName={`my-brand-frame`} iconSize={styleVars.rem(1.5)} iconColor={styleVars.boschDarkBlue}/>
              </TouchableOpacity>
            </View>
            : null
          }

        </View>
      </View>
      <Image style={styles.superGraphic} source={require('../../assets/images/supergraphic.png')}/>
    </View>
  )
}
